<form [formGroup]="form" *ngIf="form">
  <ng-content></ng-content>
  <div class="column-1">
    <div class="col">
      <h2 *ngIf="user?.first_name || user?.last_name">
        {{ user?.first_name }}
        {{ user?.last_name }}
      </h2>
      <div class="input-container">
        <label> Company Name </label>
        <mat-form-field
          appearance="outline"
          *ngIf="showCompanyDropdown"
          [ngClass]="{ 'company-dropdown-disabled': isCompanyDisabled }"
        >
          <input
            data-cy="company-name"
            matInput
            formControlName="companyName"
            [readonly]="isCompanyDisabled"
            [matAutocomplete]="auto"
            i
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option
              *ngFor="let company of filteredCompany | async"
              [value]="company"
            >
              {{ company }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="errorHandling('companyName', 'required')">
            Company Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container" *ngIf="isUserDefined()">
        <label> First Name </label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="first_name" />
          <mat-error *ngIf="errorHandling('first_name', 'required')">
            First Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container" *ngIf="isUserDefined()">
        <label> Last Name </label>
        <mat-form-field appearance="outline">
          <input matInput data-cy="last-name" formControlName="last_name" />
          <mat-error *ngIf="errorHandling('last_name', 'required')">
            Last Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container" *ngIf="form.controls?.title">
        <label> Title </label>
        <mat-form-field appearance="outline">
          <input matInput data-cy="title" formControlName="title" />
          <mat-error *ngIf="errorHandling('title', 'required')">
            Title is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container" *ngIf="form.controls?.workPhone">
        <label> Work Phone Number </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            formControlName="workPhone"
            digitalPlatformPhoneFormat
            matInput
            placeholder="_ _ _ - _ _ _ - _ _ _ _"
          />
          <mat-error *ngIf="errorHandling('workPhone', 'required')">
            Phone Number is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="errorHandling('workPhone', 'pattern')">
            Phone Number Format Must be a ___-___-____
          </mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="showRolesSelection" class="input-container">
        <label>Roles</label>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-select
            class="my-mat-select"
            formControlName="roles"
            multiple
            (selectionChange)="disableOptions($event.value)"
          >
            <mat-option value="Reset">Unselect All</mat-option>
            <mat-option value="Customer" [disabled]="customerOptionDisabled"
              >Special Waste Customer</mat-option
            >
            <mat-option
              value="Manifest"
              [disabled]="customerManifestOptionDisabled"
              >Special Waste Customer - Manifest Visibility</mat-option
            >
            <mat-option value="Samsara" [disabled]="samsaraOptionDisabled"
              >Special Waste Samsara</mat-option
            >
            <mat-option value="Sales" [disabled]="salesOptionDisabled"
              >Special Waste Sales</mat-option
            >
            <mat-option
              value="Coordinator"
              [disabled]="coordinatorOptionDisabled"
              >Special Waste Coordinator</mat-option
            >
            <mat-option value="Analyst" [disabled]="analystOptionDisabled"
              >Special Waste Analyst</mat-option
            >
            <mat-option
              value="Attendant"
              [disabled]="scaleAttendantOptionDisabled"
              >Special Waste Scale Attendant</mat-option
            >
          </mat-select>
          <mat-error *ngIf="errorHandling('roles', 'required')">
            Role is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
